// eslint-disable-next-line import/prefer-default-export
export const sortOrganizations = (organizations) => organizations
  .sort((a, b) => a.label.localeCompare(b.label));

export const sortByEnabledWithDeactivatedLabel = (items) => {
  const { enabled, disabled } = (items || []).reduce(
    (acc, item) => {
      const isDisabled = item && !(item.enabled ?? true);
      if (isDisabled) {
        acc.disabled.push({
          ...item,
          label: `[DEACTIVATED] ${item?.label || ''}`,
        });
      } else {
        acc.enabled.push(item);
      }
      return acc;
    },
    { enabled: [], disabled: [] },
  );

  return [...enabled, ...disabled];
};

export const filterByEnabled = (items, selectedItemId) => {
  const enabled = (items || []).reduce((acc, item) => {
    // if the user has already selected the item (edit modal)
    if (selectedItemId && selectedItemId === item.value) {
      // part of case data but already disabled
      if (!item?.enabled) {
        acc.push({
          ...item,
          label: `[DEACTIVATED] ${item?.label || ''}`,
        });
      } else {
        acc.push(item);
      }
    } else if (item && (item.enabled ?? false)) {
      acc.push(item);
    }

    return acc;
  }, []);

  return enabled;
};
